import { useTranslation } from 'react-i18next';
import { Affix, Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import DataFlowService from '../../../../services/DataFlow.service';
import { ROUTER } from '../../../../constants/router';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const Tab1 = ({ collectData, editMode, isNoPermission, dataFlowInfo }) => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { businessProcessId } = useParams();
    const [dataSubject, setDataSubject] = useState([]);
    const [amountDataYear, setAmountDataYear] = useState([]);
    const [lawfullbasis, setLawfullbasis] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [lawFullBasisSensitiveList, setLawFullBasisSensitiveList] = useState(
        []
    );

    useEffect(() => {
        getDataSubject();
        getAmountDataYear();
        getDepartment();
        getLawFullBasis();
        getLawFullBasisSensitive();
    }, []);

    const getLawFullBasis = async () => {
        const { data } = await DataFlowService.getLawFullBasis('general');
        if (data.resultData) {
            setLawfullbasis(data.resultData);
        }
    };

    const getLawFullBasisSensitive = async () => {
        const { data } = await DataFlowService.getLawFullBasis('sensitive');
        if (data.resultData) {
            setLawFullBasisSensitiveList(data.resultData);
        }
    };

    const getLawFullBasisSenName = (id) => {
        if (id && lawFullBasisSensitiveList?.length > 0) {
            const result = lawFullBasisSensitiveList.filter(
                (data) => data.lawfulBasisId === id
            );
            return (
                <p className="mb-0">
                    &#8226;{' '}
                    {i18n.language === 'en'
                        ? result[0]?.lawfulBasisNameEn
                        : result[0]?.lawfulBasisNameTh}
                </p>
            );
        }
    };

    const getLawFullBasisName = (id) => {
        if (id && lawfullbasis?.length > 0) {
            const result = lawfullbasis.filter(
                (data) => data.lawfulBasisId === id
            );
            return (
                <p className="mb-0">
                    &#8226;{' '}
                    {i18n.language === 'en'
                        ? result[0]?.lawfulBasisNameEn
                        : result[0]?.lawfulBasisNameTh}
                </p>
            );
        }
    };

    const getAmountDataYear = async () => {
        const { data } = await DataFlowService.getAmountDataYear();
        if (data.resultData) {
            setAmountDataYear(data.resultData);
        }
    };
    const getAmountDataYearName = (id) => {
        if (id && amountDataYear?.length > 0) {
            const result = amountDataYear.filter(
                (data) => data.statusId === id
            );
            return (
                <p key={id} className="mb-0">
                    &#8226;{' '}
                    {i18n.language === 'en'
                        ? result[0]?.nameEn
                        : result[0]?.nameTh}
                </p>
            );
        }
    };

    const getDataSubject = async () => {
        const { data } = await DataFlowService.getDataSubject();
        if (data.resultData) {
            setDataSubject(data.resultData);
        }
    };

    const getDataSubjectName = (id) => {
        if (id && dataSubject?.length > 0) {
            const result = dataSubject.filter(
                (data) => data.dataSubjectId === id
            );
            return (
                <p key={id} className="mb-0">
                    &#8226;{' '}
                    {i18n.language === 'en'
                        ? result[0]?.nameEn
                        : result[0]?.nameTh}
                </p>
            );
        }
    };
    const getDepartment = async () => {
        try {
            const { data } = await DataFlowService.getAllDepartmentList();
            if (data?.resultData) {
                setDepartmentList(data?.resultData);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getDepartmentName = (id) => {
        if (id && departmentList?.length > 0) {
            const result = departmentList.filter(
                (data) => data.departmentId === id
            );
            return (
                <p key={id} className="mb-0">
                    &#8226;{' '}
                    {i18n.language === 'en'
                        ? result[0]?.nameEn
                        : result[0]?.nameTh}
                </p>
            );
        }
    };

    const lawGroupGen = collectData?.lawfulBasis?.find(
        (lawGroup) => lawGroup.lawGroup === 'general'
    );
    const lawGroupSen = collectData?.lawfulBasis?.find(
        (lawGroup) => lawGroup.lawGroup === 'sensitive'
    );

    return (
        <div className="grid grid-cols-3">
                <div className="col-span-3 text-right mt-2 mb-2">
                    <Affix offsetTop={60}>
                        <Button
                            hidden={!editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE)}
                            type="primary"
                            style={{ padding: '0px 30px' }}
                            onClick={() => {
                                navigate(
                                    `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=1`
                                );
                            }}
                            size="large"
                            ghost
                        >
                            {t('common.Edit')}
                        </Button>
                    </Affix>
                </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.dataSubject')}
                </div>
                {collectData?.dataSubject.length > 0
                    ? collectData?.dataSubject.map((item) =>
                        getDataSubjectName(item)
                    )
                    : '-'}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.amountDataYear')}
                </div>
                {collectData?.amountDataYear &&
                    collectData?.amountDataYear !== 'addon' ? (
                    getAmountDataYearName(collectData.amountDataYear)
                ) : collectData?.amountDataYearAddOn ? (
                    <p className="mb-0">
                        &#8226; {collectData.amountDataYearAddOn}
                    </p>
                ) : (
                    '-'
                )}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.organizeDataCollection')}
                </div>
                {collectData?.organizeDataCollection?.length > 0
                    ? collectData?.organizeDataCollection?.map((item) =>
                        getDepartmentName(item)
                    )
                    : '-'}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.reasonNecessity')}
                </div>
                <p className="mb-0 whitespace-pre-wrap">
                    {collectData?.reasonNecessity
                        ? collectData.reasonNecessity
                        : '-'}
                </p>
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.lawfulBasis')}
                </div>
                {lawGroupGen
                    ? lawGroupGen?.relatedLaw.map((item) =>
                        getLawFullBasisName(item)
                    )
                    : '-'}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.lawfulBasisSensitivity')}
                </div>
                {lawGroupSen?.relatedLaw?.length > 0
                    ? lawGroupSen?.relatedLaw.map((item) =>
                        getLawFullBasisSenName(item)
                    )
                    : '-'}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.dataSource')}
                </div>
                {collectData?.dataSource || collectData?.anotherDataSource ? (
                    <>
                        {collectData?.dataSource && (
                            <>
                                <p className="mb-0 font-semibold">
                                    &#8226; {t('dataFlow.optionlawfull')}
                                </p>
                                {collectData?.dataSourceDetail ? (
                                    <p className="pl-2 whitespace-pre-line">
                                        {collectData.dataSourceDetail}
                                    </p>
                                ) : (
                                    <p className="pl-2">-</p>
                                )}
                            </>
                        )}

                        {collectData?.anotherDataSource && (
                            <>
                                <p className="mb-0 font-semibold">
                                    &#8226; {t('dataFlow.optionlawAnother')}
                                </p>
                                {collectData?.anotherDataSourceDetail ? (
                                    <p className="pl-2 whitespace-pre-wrap">
                                        {collectData.anotherDataSourceDetail}
                                    </p>
                                ) : (
                                    <p className="pl-2">-</p>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    '-'
                )}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.processUseData')}
                </div>
                <div className="whitespace-pre-wrap">
                    {collectData?.processUseData ? (
                        <p className="mb-0">{collectData.processUseData}</p>
                    ) : (
                        '-'
                    )}
                </div>
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.organizeUseData')}
                </div>

                {collectData?.organizeUseDataInSide && (
                    <>
                        <p className="mb-0 font-semibold">
                            &#8226; {t('dataFlow.inside')}
                        </p>
                        {collectData?.organizeUseDataInSideDetail ? (
                            <p className="pl-2 whitespace-pre-line">
                                {collectData.organizeUseDataInSideDetail}
                            </p>
                        ) : (
                            <p className="pl-2">-</p>
                        )}
                    </>
                )}

                {collectData?.organizeUseDataOutSide && (
                    <>
                        <p className="mb-0 font-semibold">
                            &#8226; {t('dataFlow.outside')}
                        </p>
                        {collectData?.organizeUseDataOutSideDetail ? (
                            <p className="pl-2 whitespace-pre-wrap">
                                {collectData.organizeUseDataOutSideDetail}
                            </p>
                        ) : (
                            <p className="pl-2">-</p>
                        )}
                    </>
                )}

                {collectData?.notHaveOrganizeUseData && (
                    <p className="mb-0 font-semibold">
                        &#8226; {t('No other department uses the information')}
                    </p>
                )}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.dataTransfer')}
                </div>
                {collectData?.dataTransferInSide && (
                    <>
                        <p className="mb-0 font-semibold">
                            &#8226; {t('dataFlow.inside')}
                        </p>
                        {collectData?.dataTransferInSideDetail ? (
                            <p className="pl-2 whitespace-pre-wrap">
                                {collectData.dataTransferInSideDetail}
                            </p>
                        ) : (
                            <p className="pl-2">-</p>
                        )}
                    </>
                )}

                {collectData?.dataTransferOutSide && (
                    <>
                        <p className="mb-0 font-semibold">
                            &#8226; {t('dataFlow.outside')}
                        </p>
                        {collectData?.dataTransferOutSideDetail ? (
                            <p className="pl-2 mb-0 whitespace-pre-wrap">
                                {collectData.dataTransferOutSideDetail}
                            </p>
                        ) : (
                            <p className="pl-2">-</p>
                        )}
                        <p className="mb-0 pl-2 font-semibold">
                            {t('dataFlow.inputpl5')}
                        </p>
                        {collectData?.purposeDataTransferOutSideDetail ? (
                            <p className="pl-2 whitespace-pre-wrap">
                                {collectData.purposeDataTransferOutSideDetail}
                            </p>
                        ) : (
                            <p className="pl-2">-</p>
                        )}
                    </>
                )}
                {collectData?.notHaveDataTransfer && (
                    <p className="mb-0 font-semibold">
                        &#8226; {t('Not transferred to any department')}
                    </p>
                )}
            </div>

            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.discloseToOtherPerson')}
                </div>
                <div className="whitespace-pre-wrap">
                    {collectData?.discloseToOtherPerson ? (
                        <p>{collectData.discloseToOtherPerson}</p>
                    ) : (
                        '-'
                    )}
                </div>
            </div>
            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.RightsAndMethodsOfAccessToPersonalData')}
                </div>
                <div className="whitespace-pre-wrap">
                    {collectData?.rightsAndConditionPersonalData ? (
                        <p>{collectData.rightsAndConditionPersonalData}</p>
                    ) : (
                        '-'
                    )}
                </div>
            </div>
            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.UseOrDisclosureOfPersonalInformation')}
                </div>
                <div className="whitespace-pre-wrap">
                    {collectData?.useOrDisclosurePersonalDataExceptConsent ? (
                        <p>
                            {
                                collectData.useOrDisclosurePersonalDataExceptConsent
                            }
                        </p>
                    ) : (
                        '-'
                    )}
                </div>
            </div>
            <div className="col-span-2 p-4 mb-4 box-content">
                <div className="text-lg font-semibold text-purple mb-1">
                    {t('dataFlow.PersonalDataSecurityMeasures')}
                </div>
                <div className="whitespace-pre-wrap">
                    {collectData?.securityMeasureUnder37 ? (
                        <p>{collectData.securityMeasureUnder37}</p>
                    ) : (
                        '-'
                    )}
                </div>
            </div>
        </div>
    );
};

export default Tab1;
